"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7741],{

/***/ 38945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ DecoratedButton; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n              background: ",
        ";\n              color: ",
        ";\n            "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n              background: ",
        ";\n              color: ",
        ";\n\n              &:active {\n                background-image: linear-gradient(rgb(0, 0, 0, 0.1) 0 0);\n              }\n            "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        height: 48px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n\n        ",
        "\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n              border-color: ",
        ";\n              color: ",
        ";\n            "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n              border-color: ",
        ";\n              color: ",
        ";\n\n              &:active {\n                background-image: linear-gradient(rgb(0, 0, 0, 0.1) 0 0);\n              }\n            "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n        height: 48px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n        border-width: 1px;\n        border-style: solid;\n        border-radius: ",
        "px;\n        background-color: ",
        ";\n\n        ",
        ";\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n        height: 24px;\n        color: ",
        ";\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100%;\n      border-radius: ",
        "px;\n      font-size: ",
        "px;\n      font-weight: 600;\n\n      ",
        "\n\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var buttonCSS = function(type, color, backgroundColor) {
    var isDisabled = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject7(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Radius.medium */ .wU.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .FontSizes.small */ .TS.small, type === "fill" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2(), isDisabled ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.var.gray200, theme.var.gray400) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.colors.main500, color !== null && color !== void 0 ? color : theme.true.white)), type === "border" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject5(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Radius.medium */ .wU.medium, theme.var.white, isDisabled ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject3(), theme.var.gray200, theme.var.gray400) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject4(), backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.colors.main500, backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.colors.main500)), type === "text" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject6(), color !== null && color !== void 0 ? color : theme.var.gray500));
    };
};
var Button = function(param) {
    var className = param.className, _type = param.type, type = _type === void 0 ? "fill" : _type, htmlType = param.htmlType, text = param.text, color = param.color, backgroundColor = param.backgroundColor, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
        className: className,
        type: htmlType,
        css: buttonCSS(type, color, backgroundColor, disabled),
        disabled: disabled,
        onClick: onClick,
        children: children || text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);
var DecoratedButton = function(_param) {
    var className = _param.className, decoration = _param.decoration, color = _param.color, backgroundColor = _param.backgroundColor, children = _param.children, props = _objectWithoutProperties(_param, [
        "className",
        "decoration",
        "color",
        "backgroundColor",
        "children"
    ]);
    var ref, ref1;
    var ref2;
    var _color = (ref2 = decoration === null || decoration === void 0 ? void 0 : (ref = decoration.object) === null || ref === void 0 ? void 0 : ref.textColor) !== null && ref2 !== void 0 ? ref2 : color;
    var ref3;
    var _backgroundColor = (ref3 = decoration === null || decoration === void 0 ? void 0 : (ref1 = decoration.object) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor) !== null && ref3 !== void 0 ? ref3 : backgroundColor;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Button, _objectSpreadProps(_objectSpread({
        className: className
    }, props), {
        color: _color,
        backgroundColor: _backgroundColor,
        children: children
    }));
};


/***/ }),

/***/ 93705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fr": function() { return /* binding */ isHeicImage; },
/* harmony export */   "RF": function() { return /* binding */ HEIC_ACCEPT_TYPES; },
/* harmony export */   "Wr": function() { return /* binding */ isSupportedImageFile; },
/* harmony export */   "f$": function() { return /* binding */ normalizeImageForUpload; },
/* harmony export */   "kF": function() { return /* binding */ WEBP_ACCEPT_TYPES; },
/* harmony export */   "u_": function() { return /* binding */ isWebpImage; }
/* harmony export */ });
/* unused harmony exports hasHeicFileSignature, hasWebpFileSignature, isHeicImageFile, isWebpImageFile */
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var _String;
var HEIC_MIME_TYPES = new Set([
    "image/heic",
    "image/heif",
    "image/heic-sequence",
    "image/heif-sequence", 
]);
var HEIC_EXTENSION_PATTERN = /\.(heic|heif)$/i;
var WEBP_MIME_TYPES = new Set([
    "image/webp"
]);
var WEBP_EXTENSION_PATTERN = /\.webp$/i;
var HEIC_FILE_BRANDS = new Set([
    "heic",
    "heif",
    "heix",
    "hevc",
    "hevx",
    "heim",
    "heis",
    "hevm",
    "hevs", 
]);
var FILE_TYPE_BOX = "ftyp";
var FILE_TYPE_BOX_HEADER_SIZE = 16;
var FILE_BRAND_SIZE = 4;
var FILE_SIGNATURE_READ_SIZE = 128;
var WEBP_SIGNATURE_READ_SIZE = 12;
var HEIC_ACCEPT_TYPES = [
    "image/heic",
    "image/heif",
    "image/heic-sequence",
    "image/heif-sequence",
    ".heic",
    ".heif", 
];
var WEBP_ACCEPT_TYPES = [
    "image/webp",
    ".webp"
];
var isHeicImage = function(file) {
    return HEIC_MIME_TYPES.has(file.type.toLowerCase()) || HEIC_EXTENSION_PATTERN.test(file.name);
};
var isWebpImage = function(file) {
    return WEBP_MIME_TYPES.has(file.type.toLowerCase()) || WEBP_EXTENSION_PATTERN.test(file.name);
};
var readBlobAsArrayBuffer = function(blob) {
    if (typeof blob.arrayBuffer === "function") {
        return blob.arrayBuffer();
    }
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
            return resolve(reader.result);
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        reader.readAsArrayBuffer(blob);
    });
};
var readAscii = function(bytes, offset) {
    return (_String = String).fromCharCode.apply(_String, _toConsumableArray(bytes.slice(offset, offset + FILE_BRAND_SIZE)));
};
var hasHeicFileSignature = function() {
    var _ref = _asyncToGenerator(function(file) {
        var bytes, _, boxSize, brandEnd, brands, offset;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (file.size < FILE_TYPE_BOX_HEADER_SIZE) {
                        return [
                            2,
                            false
                        ];
                    }
                    _ = Uint8Array.bind;
                    return [
                        4,
                        readBlobAsArrayBuffer(file.slice(0, FILE_SIGNATURE_READ_SIZE))
                    ];
                case 1:
                    bytes = new (_.apply(Uint8Array, [
                        void 0,
                        _state.sent()
                    ]));
                    if (readAscii(bytes, 4) !== FILE_TYPE_BOX) {
                        return [
                            2,
                            false
                        ];
                    }
                    boxSize = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength).getUint32(0);
                    if (boxSize !== 0 && boxSize < FILE_TYPE_BOX_HEADER_SIZE) {
                        return [
                            2,
                            false
                        ];
                    }
                    brandEnd = boxSize === 0 ? bytes.length : Math.min(boxSize, bytes.length);
                    brands = [
                        readAscii(bytes, 8)
                    ];
                    for(offset = FILE_TYPE_BOX_HEADER_SIZE; offset + 3 < brandEnd; offset += 4){
                        brands.push(readAscii(bytes, offset));
                    }
                    return [
                        2,
                        brands.some(function(brand) {
                            return HEIC_FILE_BRANDS.has(brand.toLowerCase());
                        })
                    ];
            }
        });
    });
    return function hasHeicFileSignature(file) {
        return _ref.apply(this, arguments);
    };
}();
var hasWebpFileSignature = function() {
    var _ref = _asyncToGenerator(function(file) {
        var bytes, _;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (file.size < WEBP_SIGNATURE_READ_SIZE) {
                        return [
                            2,
                            false
                        ];
                    }
                    _ = Uint8Array.bind;
                    return [
                        4,
                        readBlobAsArrayBuffer(file.slice(0, WEBP_SIGNATURE_READ_SIZE))
                    ];
                case 1:
                    bytes = new (_.apply(Uint8Array, [
                        void 0,
                        _state.sent()
                    ]));
                    return [
                        2,
                        readAscii(bytes, 0) === "RIFF" && readAscii(bytes, 8) === "WEBP"
                    ];
            }
        });
    });
    return function hasWebpFileSignature(file) {
        return _ref.apply(this, arguments);
    };
}();
var isHeicImageFile = function() {
    var _ref = _asyncToGenerator(function(file) {
        return __generator(this, function(_state) {
            if (isHeicImage(file)) {
                return [
                    2,
                    true
                ];
            }
            if (file.type.toLowerCase().startsWith("image/")) {
                return [
                    2,
                    false
                ];
            }
            return [
                2,
                hasHeicFileSignature(file)
            ];
        });
    });
    return function isHeicImageFile(file) {
        return _ref.apply(this, arguments);
    };
}();
var isWebpImageFile = function() {
    var _ref = _asyncToGenerator(function(file) {
        return __generator(this, function(_state) {
            if (isWebpImage(file)) {
                return [
                    2,
                    true
                ];
            }
            if (file.type.toLowerCase().startsWith("image/")) {
                return [
                    2,
                    false
                ];
            }
            return [
                2,
                hasWebpFileSignature(file)
            ];
        });
    });
    return function isWebpImageFile(file) {
        return _ref.apply(this, arguments);
    };
}();
var isSupportedImageFile = function() {
    var _ref = _asyncToGenerator(function(file) {
        var _tmp;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = file.type.toLowerCase().startsWith("image/");
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        isHeicImageFile(file)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        _tmp || isWebpImageFile(file)
                    ];
            }
        });
    });
    return function isSupportedImageFile(file) {
        return _ref.apply(this, arguments);
    };
}();
var makeJpegFilename = function(filename) {
    var basename = filename.replace(HEIC_EXTENSION_PATTERN, "").replace(WEBP_EXTENSION_PATTERN, "");
    return "".concat(basename || "image", ".jpg");
};
var canvasToJpegBlob = function(canvas) {
    return new Promise(function(resolve, reject) {
        canvas.toBlob(function(blob) {
            if (blob) {
                resolve(blob);
            } else {
                reject(new Error("Image conversion did not return a JPEG."));
            }
        }, "image/jpeg", 0.9);
    });
};
var convertWebpToJpeg = function() {
    var _ref = _asyncToGenerator(function(file) {
        var source, objectUrl, image, width, height, canvas, context, jpegBlob;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    source = WEBP_MIME_TYPES.has(file.type.toLowerCase()) ? file : new Blob([
                        file
                    ], {
                        type: "image/webp"
                    });
                    objectUrl = URL.createObjectURL(source);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        4,
                        5
                    ]);
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            var element = new Image();
                            element.onload = function() {
                                return resolve(element);
                            };
                            element.onerror = function(event) {
                                return reject(Object.assign(new Error("WebP image could not be read."), {
                                    cause: event
                                }));
                            };
                            element.src = objectUrl;
                        })
                    ];
                case 2:
                    image = _state.sent();
                    width = image.naturalWidth || image.width;
                    height = image.naturalHeight || image.height;
                    if (!width || !height) {
                        throw new Error("WebP image has invalid dimensions.");
                    }
                    canvas = document.createElement("canvas");
                    canvas.width = width;
                    canvas.height = height;
                    context = canvas.getContext("2d");
                    if (!context) {
                        throw new Error("Canvas is unavailable for image conversion.");
                    }
                    context.fillStyle = "#fff";
                    context.fillRect(0, 0, width, height);
                    context.drawImage(image, 0, 0, width, height);
                    return [
                        4,
                        canvasToJpegBlob(canvas)
                    ];
                case 3:
                    jpegBlob = _state.sent();
                    return [
                        2,
                        new File([
                            jpegBlob
                        ], makeJpegFilename(file.name), {
                            type: "image/jpeg",
                            lastModified: file.lastModified
                        })
                    ];
                case 4:
                    URL.revokeObjectURL(objectUrl);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function convertWebpToJpeg(file) {
        return _ref.apply(this, arguments);
    };
}();
var normalizeImageForUpload = function() {
    var _ref = _asyncToGenerator(function(file) {
        var ref, heic2any, result, jpegBlob;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        isWebpImageFile(file)
                    ];
                case 1:
                    if (_state.sent()) {
                        return [
                            2,
                            convertWebpToJpeg(file)
                        ];
                    }
                    return [
                        4,
                        isHeicImageFile(file)
                    ];
                case 2:
                    if (!_state.sent()) {
                        return [
                            2,
                            file
                        ];
                    }
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 3084).then(__webpack_require__.t.bind(__webpack_require__, 30833, 23))
                    ];
                case 3:
                    ref = _state.sent(), heic2any = ref.default;
                    return [
                        4,
                        heic2any({
                            blob: file,
                            toType: "image/jpeg",
                            quality: 0.9
                        })
                    ];
                case 4:
                    result = _state.sent();
                    jpegBlob = Array.isArray(result) ? result[0] : result;
                    if (!_instanceof(jpegBlob, Blob)) {
                        throw new Error("HEIC conversion did not return an image.");
                    }
                    return [
                        2,
                        new File([
                            jpegBlob
                        ], makeJpegFilename(file.name), {
                            type: "image/jpeg",
                            lastModified: file.lastModified
                        })
                    ];
            }
        });
    });
    return function normalizeImageForUpload(file) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);